export default ({ children, className = '', text = '', size = 'sm', color = 'ghost'}) => {
  
  const badgeSizeClasses = {
    xs: "badge-xs",
    sm: "badge-sm",
    md: "badge-md",
    lg: "badge-lg",
    xl: "badge-xl",
  }

  const badgeColorClasses = {
    ghost: "badge-ghost",
    primary: "badge-primary",
    secondary: "badge-secondary",
    accent: "badge-accent",
    neutral: "badge-neutral",
    info: "badge-info",
    success: "badge-success",
    warning: "badge-warning",
    error: "badge-error"
  }

  return (
    <span className={`badge ${badgeColorClasses[color]} ${badgeSizeClasses[size]} ${className}`}>
      {children || text}
    </span>
  )
}